import { useCallback, useEffect, useState } from "react";
import { loadProfitData } from "@/lib/profitsApi";
import type { ProfitPeriod, ProfitSummary } from "@/types";

export function useProfits(period: ProfitPeriod, branchId: string | null) {
  const [summary, setSummary] = useState<ProfitSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await loadProfitData(period, branchId);
      setSummary(result.summary);
      setError(result.error);
    } catch {
      setError("No se pudieron calcular las ganancias.");
      setSummary(null);
    } finally {
      setLoading(false);
    }
  }, [period, branchId]);

  useEffect(() => {
    load();
  }, [load]);

  return { summary, loading, error, reload: load };
}